/**
 * DevExtreme (core/renderer.js)
 * Version: 19.2.14
 * Build date: Tue Apr 26 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
var rendererBase = require("./renderer_base");
module.exports = rendererBase.get();
